import { render } from "./TeamControls.vue?vue&type=template&id=810234b4"
import script from "./TeamControls.vue?vue&type=script&lang=js"
export * from "./TeamControls.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__